// src/plugins/bee_bee_queue.ts
async function postAutopayInvoiceScheduler(body) {
  let honeycombOptions = this.honeycomb.honeycombOptions;
  let postAutopayInvoiceSchedulerHeaders = {
    ...honeycombOptions.requestHeaders,
    "Content-Type": "application/json",
    Accept: "application/json"
  };
  if (this.honeycomb.isRunningLocally() && body.SchedulerMode.Type === "FromDatabase") {
    throw "You should not use `FromDatabase` mode when running locally";
  }
  const postAutopayInvoiceSchedulerResponse = fetch(`${honeycombOptions.baseUrls.beehiveApimBaseUrl}/AutopayInvoiceScheduler`, {
    headers: postAutopayInvoiceSchedulerHeaders,
    body: JSON.stringify(body),
    method: "POST"
  });
  return postAutopayInvoiceSchedulerResponse;
}
function beeBeeQueuePlugin(honeycomb) {
  return {
    beeBeeQueue: {
      postAutopayInvoiceScheduler,
      honeycomb
    }
  };
}

// src/plugins/azure/azure_map.ts
async function getRoute({
  subscriptionKey,
  format = "json",
  apiVersion = "1.0",
  computeBestOrder = true,
  language = "en-US",
  ...rest
}) {
  let url = `https://atlas.microsoft.com/route/directions/${format}?`;
  url += `subscription-key=${subscriptionKey}`;
  url += `&api-version=${apiVersion}`;
  url += `&computeBestOrder=${computeBestOrder.toString()}`;
  url += `&language=${language}`;
  for (const [key, value] of Object.entries(rest)) {
    url += `&${key}=${value.toString()}`;
  }
  const response = await fetch(url, {
    headers: fetchHeaders,
    method: "GET"
  });
  const resp = await response.json();
  return resp;
}
async function searchAddress({
  subscriptionKey,
  format = "json",
  apiVersion = "1.0",
  limit = 5,
  typeahead = true,
  language = "en-US",
  countrySet = ["US"],
  ...rest
}) {
  let url = `https://atlas.microsoft.com/search/address/${format}?`;
  url += `subscription-key=${subscriptionKey}`;
  url += `&api-version=${apiVersion}`;
  url += `&limit=${limit.toString()}`;
  url += `&typeahead=${typeahead.toString()}`;
  url += `&language=${language}`;
  url += `&countrySet=${countrySet.join(",")}`;
  for (const [key, value] of Object.entries(rest)) {
    url += `&${key}=${value.toString()}`;
  }
  const response = await fetch(url, {
    headers: fetchHeaders,
    method: "GET"
  });
  const resp = await response.json();
  return resp;
}
var fetchHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
function azureMapPlugin(honeycomb) {
  return {
    azureMap: {
      getRoute,
      searchAddress,
      honeycomb
    }
  };
}

// src/plugins/my_salesman.ts
async function sendEmails({ consumerId, emailTo, emailTestData }) {
  const getTemplateMode = emailTestData === undefined ? "Email" : "EmailTest";
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const sendEmailsResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/SendEmails`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      Parameter: `{"EntityId": ${consumerId}}`,
      Mode: getTemplateMode,
      EmailTo: emailTo,
      ...emailTestData && { EmailTestData: emailTestData }
    }),
    method: "POST"
  });
  return sendEmailsResponse;
}
async function getEmailDetails(consumerId) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    Accept: "application/json"
  });
  const getEmailDetailsResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/GetEmailDetails?consumerId=${consumerId}`, {
    headers: fetchHeaders2,
    method: "GET"
  });
  return getEmailDetailsResponse;
}
async function getEmailDropoffDetails(consumerId) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    Accept: "application/json"
  });
  const getEmailDetailsResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/GetEmailDropoffDetails?consumerId=${consumerId}`, {
    headers: fetchHeaders2,
    method: "GET"
  });
  return getEmailDetailsResponse;
}
async function auth0NewUser({ email, name, userId, role }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const newUserResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/Auth0NewUser`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      email,
      name,
      UserId: userId,
      Role: role
    }),
    method: "POST"
  });
  return newUserResponse;
}
async function auth0EditUser({ email, name, entityId, isSales, isAdmin }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const newUserResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/Auth0EditUser`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      Email: email,
      Name: name,
      EntityId: entityId,
      IsSales: isSales,
      IsAdmin: isAdmin
    }),
    method: "POST"
  });
  return newUserResponse;
}
async function auth0DeleteUser({ email }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const newUserResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/Auth0DeleteUser`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      Email: email
    }),
    method: "POST"
  });
  return newUserResponse;
}
async function auth0UpdatePassword({ password }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const changePassResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/Auth0UpdatePass`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      password
    }),
    method: "POST"
  });
  return changePassResponse;
}
async function getIntegrations({ EntityId, DatabaseName }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json",
    "beehive-database-name": DatabaseName
  });
  const getIntegrationResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/GetIntegrations`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      EntityId
    }),
    method: "POST"
  });
  return getIntegrationResponse;
}
async function arcSite({ Owner, BudgetId }) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json"
  });
  const arcSiteResponse = fetch(`https://prod-22.northcentralus.logic.azure.com:443/workflows/a1507cb7c1744a43aaa78f1095e2f411/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=CgvC2fmifR6rdBHa4iQW93dUPf8UEXOxnUI1SQv2rnc`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      owner: Owner,
      budgetId: BudgetId
    }),
    method: "POST"
  });
  return arcSiteResponse;
}
async function setGroupPermissions(params) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json",
    "beehive-database-name": params.databaseName
  });
  const setGroupPermissionsResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/SetGroupPermissions`, {
    headers: fetchHeaders2,
    body: JSON.stringify(params),
    method: "POST"
  });
  return setGroupPermissionsResponse;
}
async function sewerRebase(params) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json",
    "beehive-database-name": params.databaseName
  });
  const sewerRebaseResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/SewerRebase`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      CycleId: params.cycleId,
      UserId: params.userId
    }),
    method: "POST"
  });
  return sewerRebaseResponse;
}
async function addPermissionGroup(params) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json",
    "beehive-database-name": params.databaseName
  });
  const addGroupResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/AddPermissionGroup`, {
    headers: fetchHeaders2,
    body: JSON.stringify(params),
    method: "POST"
  });
  return addGroupResponse;
}
async function billingEvent(params) {
  const honeycombOptions = this.honeycomb.honeycombOptions;
  const fetchHeaders2 = Object.assign({}, honeycombOptions.requestHeaders, {
    "Content-Type": "application/json",
    Accept: "application/json",
    "beehive-database-name": params.databaseName
  });
  const billingEventResponse = fetch(`${honeycombOptions.baseUrls.mySalesmanApimBaseUrl}/BillingEvent`, {
    headers: fetchHeaders2,
    body: JSON.stringify({
      cycleId: params.cycleId,
      userId: params.userId,
      date: params.date
    }),
    method: "POST"
  });
  return billingEventResponse;
}
function mySalesmanPlugin(honeycomb) {
  return {
    mySalesman: {
      getEmailDetails,
      sendEmails,
      honeycomb,
      auth0NewUser,
      auth0EditUser,
      auth0DeleteUser,
      auth0UpdatePassword,
      getIntegrations,
      arcSite,
      getEmailDropoffDetails,
      setGroupPermissions,
      sewerRebase,
      addPermissionGroup,
      billingEvent
    }
  };
}

// src/plugins/forager.ts
import {WebPubSubClient} from "@azure/web-pubsub-client";
async function getForagerClient(userId, tenant, metadata) {
  const honeyCombOptions = this.honeycomb.honeycombOptions;
  const rawResponse = await fetch(`${honeyCombOptions.baseUrls.foragerBaseUrl}/negotiate?userId=${userId}`, {
    headers: honeyCombOptions.requestHeaders ?? {}
  });
  const negotiateResults = await rawResponse.json();
  const webPubSubClientPromise = new Promise((resolve, _) => {
    const foragerClient = new ForagerClient(this, negotiateResults.WebSocketUrl, userId, tenant, metadata);
    resolve(foragerClient);
  });
  return webPubSubClientPromise;
}

class ForagerClient {
  serverMessageEventListeners = {
    GetDriverLocationsEventResponse: undefined,
    UpsertDriverLocationEventResponse: undefined,
    DeleteDriverLocationEventResponse: undefined
  };
  webPubSubClient;
  honeycomb;
  userId;
  tenant;
  metadata;
  constructor(honeycomb, webSocketUrl, userId, tenant, metadata) {
    this.webPubSubClient = new WebPubSubClient(webSocketUrl);
    this.honeycomb = honeycomb.honeycomb;
    this.userId = userId;
    if (tenant) {
      this.tenant = tenant;
    }
    if (metadata) {
      this.metadata = metadata;
    }
    this.webPubSubClient.on("server-message", (event) => {
      const asObject = event.message.data;
      if ("ForagerType" in asObject) {
        const foragerType = asObject["ForagerType"];
        const maybeListener = this.serverMessageEventListeners[foragerType];
        if (maybeListener) {
          maybeListener(asObject);
        }
      }
    });
  }
  async sendGetDriverLocationsEvent() {
    let eventBody = {
      ...this.tenant && { Tenant: this.tenant }
    };
    return this.webPubSubClient.sendEvent("get-driver-locations", eventBody, "json");
  }
  async sendUpsertDriverLocationEvent(latitude, longitude) {
    let eventBody = {
      Longitude: longitude,
      Latitude: latitude,
      UserId: this.userId,
      ...this.metadata && { Metadata: JSON.stringify(this.metadata) },
      ...this.tenant && { Tenant: this.tenant }
    };
    return this.webPubSubClient.sendEvent("upsert-driver-location", eventBody, "json");
  }
  async sendDeleteDriverLocationEvent() {
    let eventBody = {
      UserId: this.userId,
      ...this.tenant && { Tenant: this.tenant }
    };
    return this.webPubSubClient.sendEvent("delete-driver-location", eventBody, "json");
  }
  startService() {
    this.webPubSubClient.start();
  }
  onEventResponse(eventResponseIdentifier, listener) {
    this.serverMessageEventListeners[eventResponseIdentifier] = listener;
  }
}
function foragerPlugin(honeycomb) {
  return {
    forager: {
      getForagerClient,
      honeycomb
    }
  };
}

// src/plugins/google.ts
async function getGoogleTileCredentials(referer, apiKey) {
  let honeycombOptions = this.honeycomb.honeycombOptions;
  let headers = {
    ...honeycombOptions.requestHeaders,
    "Content-Type": "application/json",
    Accept: "application/json",
    Referer: referer
  };
  return fetch(`https://tile.googleapis.com/v1/createSession?key=${apiKey}`, {
    headers,
    body: JSON.stringify({
      mapType: "satellite",
      language: "en-US",
      region: "US",
      layerTypes: ["layerRoadmap"],
      styles: [
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ lightness: 100 }, { visibility: "simplified" }]
        }
      ]
    }),
    method: "POST"
  });
}
async function getGoogleViewportInformation(referer, apiKey, sessionKey, zoom, north, south, east, west) {
  let honeycombOptions = this.honeycomb.honeycombOptions;
  let headers = {
    ...honeycombOptions.requestHeaders,
    "Content-Type": "application/json",
    Accept: "application/json",
    Referer: referer
  };
  return fetch(`https://tile.googleapis.com/tile/v1/viewport?session=${sessionKey}&key=${apiKey}&zoom=${zoom}&north=${north}&south=${south}&east=${east}&west=${west}`, {
    headers,
    method: "GET"
  });
}
function googlePlugin(honeycomb) {
  return {
    google: {
      getGoogleViewportInformation,
      getGoogleTileCredentials,
      honeycomb
    }
  };
}
// package.json
var package_default = {
  name: "@beehive-development/honeycomb",
  version: "1.1.7",
  scripts: {
    build: "bun run scripts/build.ts",
    verify: "bun test -t \"<Honeycomb>\"",
    "purty:write": "bunx --bun prettier . --write",
    "purty:check": "bunx --bun prettier . --check"
  },
  dependencies: {
    "@azure/web-pubsub-client": "^1.0.0-beta.3"
  },
  devDependencies: {
    "@esbuild-plugins/node-globals-polyfill": "^0.2.3",
    "@esbuild-plugins/node-modules-polyfill": "^0.2.2",
    "bun-plugin-dts": "^0.2.1",
    "bun-types": "latest",
    prettier: "^3.0.3",
    typescript: "^5.0.2"
  },
  repository: {
    type: "git",
    url: "git://github.com/Beehive-Development/honeycomb.git"
  },
  types: "index.d.ts"
};

// src/types.ts
class HoneycombClient {
  static honeycombPlugins = [];
  honeycombOptions;
  constructor(honeycombOptions) {
    this.honeycombOptions = honeycombOptions;
    const honeycombConstructor = this.constructor;
    honeycombConstructor.honeycombPlugins.forEach((x) => {
      Object.assign(this, x(this, honeycombOptions));
    });
  }
  static defaults(defaults) {
    const HoneycombWithDefaults = class extends this {
      constructor(...args) {
        super(Object.assign({}, defaults, args[0] || {}));
      }
    };
    return HoneycombWithDefaults;
  }
  static attachPlugins(...plugins) {
    const existingPlugins = this.honeycombPlugins;
    const NewHoneycomb = class extends this {
      static honeycombPlugins = existingPlugins.concat(plugins.filter((x) => !existingPlugins.includes(x)));
    };
    return NewHoneycomb;
  }
  isRunningLocally() {
    return Object.values(this.honeycombOptions.baseUrls).every((x) => x.includes("localhost"));
  }
}
// src/utility.ts
var isOnMobile = () => {
  const mobileUserAgents = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  return mobileUserAgents.some((x) => navigator.userAgent.match(x));
};

// src/index.ts
var DefaultHoneycombClient = HoneycombClient.attachPlugins(foragerPlugin, mySalesmanPlugin, beeBeeQueuePlugin, azureMapPlugin, googlePlugin).defaults({
  baseUrls: {
    foragerBaseUrl: "https://forager.azurewebsites.net/api",
    beehiveApimBaseUrl: "https://beehive.azure-api.net",
    mySalesmanApimBaseUrl: "https://bhmysalesman.azure-api.net/bhMySalesman"
  },
  requestHeaders: {
    "User-Agent": `honeycomb/${package_default.version}`
  }
});
var src_default = DefaultHoneycombClient;
export {
  isOnMobile,
  src_default as default,
  HoneycombClient,
  ForagerClient
};
